import { Rate, Row } from 'antd';
import React from 'react';
import multiplePaymentSelectors from '../pages/PaymentPage/services/selectors';
type Props = {
  billId?: string;
};
const SocketRatingTicket = ({ billId }: Props) => {
  const data = multiplePaymentSelectors.customerSide.getTicketRatingStar();

  if (!billId) return null;
  if (data?.billId !== billId) return null;

  return (
    <Row justify={'center'} style={{ gap: 16, marginBottom: 16 }}>
      <Rate
        disabled
        style={{ zoom: 2 }}
        value={data?.rating || 0}
        count={5}
        character={({ value = 0, index = 0 }) => (index + 1) <= value ? <StarFill /> : <Star />}
      />
    </Row>
  );
};

export default SocketRatingTicket;

const StarFill = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="28" viewBox="0 0 31 28" fill="none">
    <path d="M15.4528 0.0471191L18.9222 10.7248H30.1493L21.0664 17.3239L24.5358 28.0016L15.4528 21.4024L6.36988 28.0016L9.83926 17.3239L0.756315 10.7248H11.9835L15.4528 0.0471191Z" fill="#FF7D00" />
  </svg>
);
const Star = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28" fill="none">
    <path d="M15.0759 0.0471191L18.5453 10.7248H29.7724L20.6894 17.3239L24.1588 28.0016L15.0759 21.4024L5.99293 28.0016L9.46231 17.3239L0.379362 10.7248H11.6065L15.0759 0.0471191Z" fill="#E5E5E5" />
  </svg>
);
